/**
 * 历史报警相关接口
 */

import instance from '@/utils/axios';

/** @typedef {{code:number, data: any, message: string}} IResult */

/**
 * 获取历史数据
 * sn 设备号
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * alarmType 报警类型
 * offset 分页位置
 * limit 每页数量
 */
export function getHistoryData(data) {
  return instance.post('/devicedata/hisAlarm', { ...data });
}

/**
 * 获取GD606设备历史数据
 * dataType 数据类型
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * offset 分页位置
 * limit 每页数量
 */
export function getGD606History(data) {
  return instance.post('/devicedata/hisGd606', { ...data });
}

/**
 * 获取历史报警的详细信息
 * @param {报警事件id} id
 */
export function getHistoryDetailData(id) {
  return instance.get('/devicedata/hisAlarmDetail', {
    params: {
      eventId: id
    }
  });
}

/**
 * 检测记录相关接口
 */

/**
 * 获取检测记录数据
 * sn 设备号
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * offset 分页位置
 * limit 每页数量
 */
export function getHisDetect(data) {
  return instance.post('/devicedata/hisDetect', { ...data });
}

/**
 * 获取检测记录的详情
 * @param {报警事件id} id
 */
export function getHisDetectDetail(data) {
  return instance.get('/devicedata/hisDetectDetail', {
    params: {
      ...data
    }
  });
}

/**
 * 获取设备状态数据
 * sn 设备号
 * runstate 设备状态
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * offset 分页位置
 * limit 每页数量
 */
export function getHisState(data) {
  return instance.post('/devicedata/hisState', { ...data });
}

/**
 * 获取采样设备历史数据
 * beginTime 查询开始时间
 * endTime 查询结束时间
 * offset 分页位置
 * limit 每页数量
 */
export function getSampleHistory(data) {
  return instance.post('/devicedata/hisSampleData', { ...data });
}

/**
 * 获取历史故障记录
 * @param {{ sn: String[], officeId: String[], taskId: String[], beginTime: Number, endTime: Number, offset: Number, limit: Number }} data
 * @returns {Promise}
 */
export function getFaultRecords(data) {
  return instance.post('/devicedata/hisFault', { ...data });
}

/**
 * 处置报警信息
 * @param {{ ids: string[], dispositionInfo: string }} data
 * @returns {Promise<IResult>}
 */
export function disposeAlarmInfo(data) {
  return instance.post('/devicedata/updateDispositionInfo', { ...data });
}

/**
 * 核素查询
 * @param {*} data
 * @returns
 */
export function nuclideListServer(data) {
  return instance.get('/stat/queryRg05NuclideOrdata', {
    params: {
      ...data
    }
  });
}

export function rm1000NuclideOrdataServer(data) {
  return instance.get('/stat/queryRm1000NuclideOrdata', {
    params: {
      ...data
    }
  });
}

/**
 * 设备报警演练
 * @param {Object} data
 * @param {string} data.sn
 * @param {1|2} data.alarmStatus 1-开始 2-结束
 * @param {1|1101|2101|3101|4101|7101|3201|3202|3203} data.alarmType 数值报警-1 烟雾-1101 生物-2101 有毒有害-3101 化学战剂-4101 核-7101 一氧化碳-3203 氨气-3201 氯气-3202
 * @returns
 */
export function setDeviceAnalogAlarm(data) {
  return instance.post('/devicedata/drillAlarm', data);
}

/**
 * 自动合并报警
 * @param {Object} data
 * @param {string[]} data.officeId
 * @param {string[]} data.deviceModel
 * @param {number} data.beginTime
 * @param {number} data.endTime
 */
export function autoMergeAlarm(data) {
  return instance.post('/devicedata/autoMergeAlarm', data);
}

/**
 * 获取GD606|GD612 设备回放列表
 * @param {Object} data
 * @param {number} data.offset
 * @param {number} data.limit
 * @param {number} data.beginTime
 * @param {number} data.endTime
 * @param {string[]} data.sns
 * @param {string[]} data.officeIds
 * @param {string[]} data.deviceTypeCode
 * @returns
 */
export function getGDReplayList(data) {
  return instance.post('/deviceTrack/gdReplayList', data);
}

/**
 * 获取 GD606|GD612 设备回放数据
 * @param {Object} data
 * @param {number} data.beginTime
 * @param {number} data.endTime
 * @param {string} data.sn
 * @returns
 */
export function getGDReplayData(data) {
  return instance.post('/deviceTrack/gdReplay', data);
}

/**
 * 获取 cd603 设备数据
 * @param {Object} data
 * @param {string} data.sn
 * @param {string} data.sns
 * @param {string} data.officeId
 * @param {string} data.officeIds
 * @param {string} data.beginTime
 * @param {string} data.endTime
 * @param {number} data.offset
 * @param {number} data.limit
 * @returns
 */
export function getCD603DataList(data) {
  return instance.post('/cd603-devicedata/dataList', data);
}

/**
 * EFM100查询列表及详情 api
 *
 */
export function getEFM100CheckList(data) {
  return instance.post('/devicedata/hisDetectExplosionive', { ...data });
}
// 详情
export function getEFM100CheckDetail(data) {
  return instance.get('/devicedata/hisDetectDetailExplosion', {
    params: {
      ...data
    }
  });
}
